import React from 'react';
import classes from './Button.module.css';

const button = (props) => (
    <button
        className={[classes.Button, classes[props.btnType]].join(' ')} // the className accepts a STRING!!!
        onClick={props.clicked}
        disabled={props.isDisabled}>{props.children}</button>
);

export default button;